import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=5391ebd8&scoped=true&"
import script from "./TabsContainer.vue?vue&type=script&lang=ts&"
export * from "./TabsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TabsContainer.vue?vue&type=style&index=0&id=5391ebd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391ebd8",
  null
  
)

export default component.exports